import React, { useEffect } from 'react';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Header } from '../../../components/header/header';
import Strings from '../../../i18n';
import {
  ButtonIconStyled,
  TitleStyled
} from '../../../views/devices/devicesStyles';
import { ContainerStyled } from '../../../components/layout/main/mainStyles';
import { useGetDeviceEventTableMutation } from '../../../services/device/deviceService';
import { ContainerTable } from '../../locations/locationsList/locationListStyles';

export const EventTableByDevice = () => {
  const { deviceId } = useParams();
  const [getEventTable, { data, isSuccess }] = useGetDeviceEventTableMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (deviceId) {
      getEventTable(deviceId);
    }
  }, []);

  return (
    <>
      <Header>
        <ContainerStyled>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBack />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <TitleStyled>
                {Strings.serverAccess.devices.actionsTable}
                <Typography variant="subtitle2">{deviceId}</Typography>
              </TitleStyled>
            </div>
            <div className="col-8 col-sm-4 text-right" />
          </div>
        </ContainerStyled>
      </Header>
      <ContainerTable component="main">
        {isSuccess && data && (
          <DataTable
            value={data}
            size="small"
            scrollable
            paginator={data && data.length >= 50}
            selectionPageOnly
            scrollHeight="flex"
            rows={50}
            rowsPerPageOptions={[5, 10, 25, data ? data.length : 50]}
            tableStyle={{ fontSize: '14px' }}
          >
            <Column
              field="controllerDateRange"
              header="Controller Date Range"
              sortable
            />
            <Column
              field=" serverDateRange"
              header="Server Date Range"
              sortable
            />
            <Column field="weekDays" header="Week Days" sortable />
            <Column field="timeType" header="Time Type" sortable />
            <Column field="eventName" header="Event Name" sortable />
          </DataTable>
        )}
      </ContainerTable>
    </>
  );
};
